import axios from 'axios';
import { BASE_URL } from '../config/config'

export const sendInvite = async (email) => {
    const res = await axios.post(`${BASE_URL}/api/v1/invitation`, { email });
    return res;
}